/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum CharacteristicDataType {
  BOOLEAN = "BOOLEAN",
  FLOAT = "FLOAT",
  ONE_BOOLEAN_PER_CHARACTERISTIC = "ONE_BOOLEAN_PER_CHARACTERISTIC",
  ONE_BOOLEAN_PER_PRODUCT = "ONE_BOOLEAN_PER_PRODUCT",
  ONE_FLOAT_PER_CHARACTERISTIC = "ONE_FLOAT_PER_CHARACTERISTIC",
  ONE_TEXT_PER_PRODUCT = "ONE_TEXT_PER_PRODUCT",
  TEXT = "TEXT",
}

export enum CharacteristicLanguage {
  de = "de",
  en = "en",
  zh = "zh",
}

export enum DataProgress {
  COMPLETED = "COMPLETED",
  NOT_STARTED = "NOT_STARTED",
  STARTED = "STARTED",
}

export enum DataValidation {
  NOT_TESTED = "NOT_TESTED",
  TESTED_NOK = "TESTED_NOK",
  TESTED_NOK_CRITICAL = "TESTED_NOK_CRITICAL",
  TESTED_OK = "TESTED_OK",
}

export enum OperationResult {
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
}

export enum PdfLayout {
  DECKMATE = "DECKMATE",
  DEMO = "DEMO",
  STANDARD = "STANDARD",
}

/**
 * Product info properties
 */
export enum ProductInfoProperties {
  ARTICLE_NUMBER = "ARTICLE_NUMBER",
  CUSTOMER = "CUSTOMER",
  CUSTOMER_ARTICLE_NO = "CUSTOMER_ARTICLE_NO",
  CUSTOMER_DRAWING_NUMBER = "CUSTOMER_DRAWING_NUMBER",
  CUSTOMER_PRODUCT_DESCRIPTION = "CUSTOMER_PRODUCT_DESCRIPTION",
  CUTTING_LINES = "CUTTING_LINES",
  DIAMETER = "DIAMETER",
  DRAWING_1 = "DRAWING_1",
  DRAWING_2 = "DRAWING_2",
  DRAWING_3 = "DRAWING_3",
  DRAWING_NUMBER = "DRAWING_NUMBER",
  EAN_CODE = "EAN_CODE",
  GROSS_WEIGHT = "GROSS_WEIGHT",
  HEAD = "HEAD",
  HEAD_STAMP = "HEAD_STAMP",
  LENGTH = "LENGTH",
  MARKING_ACC = "MARKING_ACC",
  MATERIAL_WIRE = "MATERIAL_WIRE",
  NAME_OF_PRODUCT = "NAME_OF_PRODUCT",
  NET_WEIGHT = "NET_WEIGHT",
  NUMBER = "NUMBER",
  POINT = "POINT",
  PRODUCT_TYPE = "PRODUCT_TYPE",
  RECESS_SIZE = "RECESS_SIZE",
  RECESS_TYPE = "RECESS_TYPE",
  RUST_RESISTANCE = "RUST_RESISTANCE",
  SCREW_TYPE = "SCREW_TYPE",
  SHAFT_CONSTRUCTION = "SHAFT_CONSTRUCTION",
  SURFACE_COATING = "SURFACE_COATING",
  SURFACE_COLOR = "SURFACE_COLOR",
  SURFACE_IN_MM2 = "SURFACE_IN_MM2",
  SURFACE_THICKNESS = "SURFACE_THICKNESS",
  TECHNICAL_DRAWING = "TECHNICAL_DRAWING",
  THREAD_LENGTH_MM = "THREAD_LENGTH_MM",
  THREAD_LENGTH_NAME = "THREAD_LENGTH_NAME",
  THREAD_TYPE = "THREAD_TYPE",
  UNDER_HEAD_CONSTRUCTION = "UNDER_HEAD_CONSTRUCTION",
  WAX = "WAX",
}

export enum ProductTemplateValidationErrorType {
  CHARACTERISTIC_NOT_ASSIGNED = "CHARACTERISTIC_NOT_ASSIGNED",
  PRODUCT_DOES_NOT_EXIST = "PRODUCT_DOES_NOT_EXIST",
  TEMPLATE_DOES_NOT_EXIST = "TEMPLATE_DOES_NOT_EXIST",
}

export enum ProductValidationErrorType {
  COMPANY_DOES_NOT_EXIST = "COMPANY_DOES_NOT_EXIST",
  MISSING_REQUIRED_PROPERTY = "MISSING_REQUIRED_PROPERTY",
  PRODUCT_EXISTS = "PRODUCT_EXISTS",
  UNALLOWED_MULTIPLE_VALUES = "UNALLOWED_MULTIPLE_VALUES",
  UNKNOWN_CHARACTERISTIC = "UNKNOWN_CHARACTERISTIC",
  UNKNOWN_VALUE = "UNKNOWN_VALUE",
}

export enum ReportStep {
  COMPLETED = "COMPLETED",
  CREATED = "CREATED",
  DONE_GATHERING = "DONE_GATHERING",
  IN_PROGRESS = "IN_PROGRESS",
}

/**
 * Userrole
 */
export enum Role {
  admin = "admin",
  supervisor = "supervisor",
  tester = "tester",
  viewer = "viewer",
}

export enum SetReportDateResponse {
  ERROR = "ERROR",
  SUCCESS = "SUCCESS",
}

export enum SetReportDateType {
  DATA_ENTRY_END = "DATA_ENTRY_END",
  DATA_ENTRY_START = "DATA_ENTRY_START",
  REPORT_COMPLETE = "REPORT_COMPLETE",
}

export enum UploadFileResponse {
  FILE_EXISTS = "FILE_EXISTS",
  NOT_ALLOWED = "NOT_ALLOWED",
  SUCCESS = "SUCCESS",
}

export interface CharactersticKeyInput {
  lang: CharacteristicLanguage;
  value: string;
}

export interface EditReportProductInput {
  id: string;
  materialCertificate?: string | null;
  heatNr?: string | null;
  batch?: string | null;
  orderQuantity?: number | null;
  selectedTemplate: TemplateInput;
  measurements?: MeassurmentType[] | null;
  woodInfo?: WoodInfoInput | null;
  existed: boolean;
  sheetId: string;
}

export interface MeassurmentType {
  characteristic: string;
  values: string[];
}

export interface PrintPdfSettingsInput {
  pdfAttachments: boolean;
  materialCertificate: boolean;
  technicalDrawing: boolean;
  characteristicAttachments: boolean;
  imageAttachments: boolean;
}

export interface ProductCharacteristicsCustomShortcutInput {
  characteristicId: number;
  customShortcut: string;
}

export interface ProductImportInput {
  properties: ProductPropertyImportInput[];
  productCharacteristicsCustomShortcuts: ProductCharacteristicsCustomShortcutInput[];
}

export interface ProductInput {
  id: string;
  materialCertificate?: string | null;
  heatNr?: string | null;
  batch?: string | null;
  orderQuantity?: number | null;
  selectedTemplate: TemplateInput;
  measurements?: MeassurmentType[] | null;
  woodInfo?: WoodInfoInput | null;
}

export interface ProductPropertyImportInput {
  key: string;
  values: string[];
}

export interface ProductPropertyTemplateDataImportInput {
  article_number?: string | null;
  boolean?: string | null;
  characeristic_key?: string | null;
  max?: string | null;
  min?: string | null;
  order?: string | null;
  template?: string | null;
  TT?: string | null;
  KUN?: string | null;
}

export interface ReportInfoProperties {
  name: string;
  orderConfirmation: string;
  customerOrderNumber: string;
  shippingDate: any;
  orderDate?: any | null;
  customer?: string | null;
  supplier?: string | null;
  productionPlant?: string | null;
  work_order_nr?: string | null;
}

export interface SaveMeasurementsInput {
  characteristicsId: string;
  shortcut: string;
  values: (string | null)[];
}

export interface SheetInfo {
  materialCertificate?: string | null;
  heatNr?: string | null;
  batch?: string | null;
  orderQuantity?: number | null;
}

export interface TemplateCharacteristicsOrderInput {
  characteristicId: string;
  order: number;
}

export interface TemplateInput {
  id: string;
}

export interface WoodInfoInput {
  woodNr?: string | null;
  insertionDirection?: string | null;
  woodMoisture?: string | null;
  woodDensity?: string | null;
  roomTemperature?: string | null;
  roomMoisture?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
